<template>
  <a-modal
    title="谷歌二次安全验证"
    :width="500"
    :visible="googleauthStatus"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item>
          <a-input
            v-decorator="['google_code', {rules: [{required: true, message: '必填项'}]}]"
            size="large"
            placeholder="谷歌6位动态密码"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import AuthApi from '@/api/auth'
export default {
  components: {},
  data() {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    googleauthStatus() {
      return this.$store.state.googleauth.status
    }
  },
  created() {},
  methods: {
    handleCancel() {
      this.$store.dispatch('googleauthUpdateStatus', { status: false })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
            AuthApi.checkGoogleAuth({
              google_code:values.google_code,
            })
            .then((res) => {
              if (res.code === 1) {
                Vue.ls.set('GoogleAuthMark', res.data, 30 * 60 * 1000)
                this.form.resetFields()
                this.$message.success("验证成功");
                this.$store.dispatch('googleauthUpdateStatus', { status: false })
              } else {
                this.$message.error(res.msg);
              }
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
